import { render, staticRenderFns } from "./testWikiViewer.vue?vue&type=template&id=5bc5c1f4&scoped=true&"
import script from "./testWikiViewer.vue?vue&type=script&lang=js&"
export * from "./testWikiViewer.vue?vue&type=script&lang=js&"
import style0 from "./testWikiViewer.vue?vue&type=style&index=0&id=5bc5c1f4&prod&lang=scss&scoped=true&"
import style1 from "./testWikiViewer.vue?vue&type=style&index=1&id=5bc5c1f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5c1f4",
  null
  
)

export default component.exports